import {
    INCREMENT_FAILED_ATTEMPTS,
    SET_CONFIG,
    SET_CONFIG_KEY,
    UI_INITIALIZE,
    UPDATE_ID
} from '-/actions/types';
import {set} from '-/util/lodash';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
    const {type, value, payload = {}} = action;
    const {failedAttempts} = payload;

    switch (type) {
        case SET_CONFIG:
            return {
                ...state,
                ...value
            };
        case SET_CONFIG_KEY: {
            const {key, value: update} = value;
            const data = {...state};

            set(data, key, update);

            return data;
        }
        case UI_INITIALIZE:
            return {
                ...state,
                ...value.config
            };
        case UPDATE_ID:
            return {
                ...state,
                offerId: value
            };
        case INCREMENT_FAILED_ATTEMPTS:
            return {
                ...state,
                failedAttempts
            };
    }

    return state;
};
